import eeAbout from "@assets/events-awards/ee/img-ee-about.png";
import { BlockTitle } from "@blocks/Blocks";

import { JUDGES_PANEL_LIST } from "./EEConstants";

/**
 * Component to render EE about page
 */
const EEAboutPage = (): React.ReactElement => {
  return (
    <div
      data-testid="ee-about-page-component"
      className="mb-5 font-public-sans"
    >
      <BlockTitle
        text="About"
        rootClassName="pt-3 pb-2 text-4xl text-xl lg:text-8xl font-medium"
      />

      <div className="flex flex-col py-4 md:flex-row">
        <div className="mb-4 w-full leading-[1.4] md:mb-0 md:pr-3 lg:w-1/2">
          <p className="font-bold">DO WELL, DO GOOD, DO NOW</p>

          <p>
            Applicants shortlisted into the Emerging Enterprise Awards and
            Emerging Enterprise Sustainability Awards undergo a rigorous 2-part
            judging process: Site visits (Physical and/or Virtual) as well as
            live Judging for applicants to present their business model,
            products and services to a panel of distinguished judges.
          </p>

          <p className="mb-0">
            The carefully selected expert judging panel will review each entry
            based on the criteria set within each category, whilst also applying
            three key principles:
          </p>

          <ul className="list-outside list-disc pl-8">
            <li>Clear and concise results and metrics</li>
            <li>
              Measurable evidence of innovation, impact and scalability, with
              demonstrable, long-term commitment to a sustainable transformation
            </li>
            <li>Relevance award category criteria</li>
          </ul>
        </div>

        <div className="w-full md:pl-3 lg:w-1/2">
          <img
            src={eeAbout}
            width={576}
            height={283}
            alt="Emerging Enterprise About"
            className="object-contain"
          />
        </div>
      </div>

      <BlockTitle
        text="Judges Panel"
        rootClassName="pt-6 mt-8 pb-2 text-4xl text-xl lg:text-8xl font-medium"
      />

      {JUDGES_PANEL_LIST.map((member, index) => {
        const { partner, name, position, description, imageUrl } = member;

        return (
          <div key={index + name} className="flex flex-col py-3 md:flex-row">
            <div className="mb-2 h-auto w-7/10 pr-4 md:mb-0 md:w-3/12">
              <img
                src={imageUrl}
                width={576}
                height={283}
                alt={name}
                className="object-contain"
              />
            </div>

            <div className="md:w-9/12 md:pl-2">
              <p className="mb-0 font-bold">{partner}</p>

              <p className="mb-0 font-bold">{name}</p>

              <p className="mb-0 font-bold">{position}</p>

              <p className="leading-[1.4]">{description}</p>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default EEAboutPage;
